import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import CURRENT_PLAY_ICON from '@src/framework/frame-pc/components/play-menu-item/img/titlebar-slide-show-currentpage.svg';

export const config = {
    id: ActionType.LOCAL_PLAY_FROM_CURRENT,
    icon: CURRENT_PLAY_ICON,
    content: i18n.t('从当前页演示'),
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        text: config.content,
        style: {
        },
        tooltip: config.content,
    },
];


export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        icon: <img src={config.icon} alt={''}/>,
    },
];
